/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type PlanDetailSourceType =
  (typeof PlanDetailSourceType)[keyof typeof PlanDetailSourceType];

export const PlanDetailSourceType = {
  DIRECT_PURCHASE: 'DIRECT_PURCHASE',
  VOUCHER: 'VOUCHER',
  ADMIN_GRANT: 'ADMIN_GRANT',
  EVENT_GRANT: 'EVENT_GRANT',
} as const;
